import { FeatureTags } from '@spazious/dollhouse-types';

export const FEATURES_TAGS: FeatureTags[] = [
  'decorations',
  'farrangements',
  'fensembles',
  'flayouts',
  'furnitures',
  'inspector',
  'graphs.setup',
  'graphs.setup:editable',
  'graphs.setup.node',
  'graphs.setup.node:editable',
  'graphs.setup.node.attrs',
  'graphs.setup.node.attrs:editable',
  'graphs.setup.node.meta',
  'graphs.setup.node.meta:editable',
  'graphs.setup.node.props',
  'graphs.setup.node.props:editable',
  'graphs.setup.node.decoration',
  'graphs.setup.node.decoration:editable',
  'graphs.setup.node.annotation',
  'graphs.setup.node.annotation:editable',
  'hud',
  'records',
  'real-time-sharing',
  'session',
  'share',
  'templates',
  'tool.view',
  'tool.select',
  'tool.move',
  'tool.duplicate',
  'tool.ruler',
  'tool.draw',
  'tool.farea',
  'tool.numbering',
  'tool.camerapath',
  'devtools',
];
